<ejs-dialog #editProductAssetDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancel()"
  (open)="onOpen($event)">
  <ng-template #header>
    @if (!assetStorageUploadEditorForm.controls.id.value) {
      <div>{{'i18n.domain.assets.asset-storage.edit-asset-storage.assign-asset' | translate}}</div>
    } @else {
      {{'i18n.domain.assets.asset-storage.edit-asset-storage.edit-asset' | translate}}
    }
  </ng-template>

  @if (assetStorageUploadEditorForm) {
    <app-asset-storage-edit-tab-group #assetStorageEditTabGroupComponent
                                      [assetStorageUploadEditorForm]="assetStorageUploadEditorForm"
                                      (setScreenSize)="setScreenSize($event)">
    </app-asset-storage-edit-tab-group>
  }

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-flat"
              (click)="onCancel()">
        {{'i18n.shared.cancel' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-primary e-flat"
              (click)="onSave()"
              [disabled]="!canSave">
        {{'i18n.shared.save' | translate}}
      </button>
    </ng-container>
  </ng-template>
</ejs-dialog>
